import { Button } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../../../../../components/modal/Dialog";

export const DeleteDraftOrderDialog = ({
  active,
  setActive,
  onDelete,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
  onDelete: () => void;
}) => {
  return (
    <Dialog
      active={active}
      onDismiss={() => setActive(false)}
      className="h-fit" // required to prevent full height on mobile dialog
    >
      <DialogNavigation
        title={`Are you sure you wish to remove this basket?`}
      />
      <DialogCTA className="full-width flex justify-center">
        <div className="flex gap-2">
          <Button color={"transparent"} onClick={() => setActive(false)}>
            Dismiss
          </Button>
          <Button color={"red"} onClick={() => onDelete()}>
            Delete
          </Button>
        </div>
      </DialogCTA>
    </Dialog>
  );
};
